<template>
  <v-main class="page-form-main-instruction">
    <portal to="app-bar">
      <v-app-bar
        app
        color="secondary"
        dark
      >
        <v-btn
          icon
          @click="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title>{{ $t('form.show.job-instruction') }}</v-toolbar-title>
      </v-app-bar>
    </portal>

    <v-container>
      <div
        class="prevent-overflow"
        v-html="project.description"
      />
    </v-container>

    <v-footer
      v-if="project && project.descriptionFile"
      app
    >
      <v-row>
        <v-col>
          <v-btn
            color="primary"
            block
            large
            target="_blank"
            :href="project.descriptionFile"
          >
            {{ $t('notifications.download_attachment') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
  </v-main>
</template>

<script>
export default {
  props: {
    project: { type: Object, required: true }
  }
};
</script>

<style lang="scss" scoped>
.prevent-overflow {
  overflow: hidden;
  word-break: break-word;
  img {
    max-width: 100%;
  }
}
</style>
